/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Group_ProgressingInputs */

const en_us2_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressing`)
};

const pt_br2_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progredindo`)
};

const es_419_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresando`)
};

const pt_pt2_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A progredir`)
};

const fr_fr2_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En progrès`)
};

const de_de2_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steigend`)
};

const it_it2_progress_report_group_progressing = /** @type {(inputs: Progress_Report_Group_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progresso`)
};

/**
* | output |
* | --- |
* | "Progressing" |
*
* @param {Progress_Report_Group_ProgressingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_group_progressing = /** @type {((inputs?: Progress_Report_Group_ProgressingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Group_ProgressingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_group_progressing(inputs)
	if (locale === "es-419") return es_419_progress_report_group_progressing(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_group_progressing(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_group_progressing(inputs)
	if (locale === "de-DE") return de_de2_progress_report_group_progressing(inputs)
	if (locale === "it-IT") return it_it2_progress_report_group_progressing(inputs)
	return en_us2_progress_report_group_progressing(inputs)
});
export { progress_report_group_progressing as "progress-report.group_progressing" }